import { SET_LIVES } from './constants';

export const setLives = list => ({
  type: SET_LIVES,
  payload: list,
});
